module.exports = __webpack_public_path__ + "static/media/mixkit-money-bag-drop-1989.9abd75a4.wav";